import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Menu, X, LogOut, LayoutDashboard } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

const Nav = () => {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const links = [
    { to: "/shop", label: "Shop" },
    { to: "/shop?category=Kurti", label: "Kurtis" },
    { to: "/shop?category=Suit", label: "Suits" },
    { to: "/refund-policy", label: "Refunds" },
    { to: "/customer-service", label: "Support" },
  ];

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F8F6]/90 border-b border-[#E5E1D8]">
      <nav className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="font-serif text-2xl md:text-3xl tracking-tight text-[#1A1A1A] leading-none">
          Anhad
          <span className="block font-mono text-[9px] uppercase tracking-[0.35em] text-[#8C3A3A] mt-0.5">Collections</span>
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#1A1A1A] hover:text-[#8C3A3A] transition-colors duration-300"
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-5">
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" title="Admin" className="hidden md:block text-[#1A1A1A] hover:text-[#8C3A3A] transition-colors">
              <LayoutDashboard size={19} />
            </Link>
          )}
          {user ? (
            <div className="hidden md:flex items-center gap-4">
              <Link to="/orders" data-testid="nav-orders" className="font-mono text-[11px] uppercase tracking-[0.18em] hover:text-[#8C3A3A] transition-colors">Orders</Link>
              <button data-testid="logout-btn" onClick={() => { logout(); navigate("/"); }} className="text-[#1A1A1A] hover:text-[#8C3A3A] transition-colors"><LogOut size={18} /></button>
            </div>
          ) : (
            <Link to="/login" data-testid="nav-login" className="hidden md:block text-[#1A1A1A] hover:text-[#8C3A3A] transition-colors"><User size={19} /></Link>
          )}
          <Link to="/cart" data-testid="nav-cart" className="relative text-[#1A1A1A] hover:text-[#8C3A3A] transition-colors">
            <ShoppingBag size={20} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-[#8C3A3A] text-white text-[10px] font-mono w-4 h-4 flex items-center justify-center">{count}</span>
            )}
          </Link>
          <button data-testid="mobile-menu-btn" className="md:hidden text-[#1A1A1A]" onClick={() => setOpen(!open)}>
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-[#E5E1D8] bg-[#F9F8F6] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="font-mono text-xs uppercase tracking-[0.18em]">{l.label}</Link>
          ))}
          {user ? (
            <>
              <Link to="/orders" onClick={() => setOpen(false)} className="font-mono text-xs uppercase tracking-[0.18em]">Orders</Link>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="font-mono text-xs uppercase tracking-[0.18em]">Admin</Link>}
              <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="text-left font-mono text-xs uppercase tracking-[0.18em] text-[#8C3A3A]">Logout</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)} className="font-mono text-xs uppercase tracking-[0.18em]">Login</Link>
          )}
        </div>
      )}
    </header>
  );
};

export default Nav;
